import { render, staticRenderFns } from "./EditableLessonResourceItem.vue?vue&type=template&id=06b471b8&scoped=true&"
import script from "./EditableLessonResourceItem.vue?vue&type=script&lang=js&"
export * from "./EditableLessonResourceItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableLessonResourceItem.vue?vue&type=style&index=0&id=06b471b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b471b8",
  null
  
)

export default component.exports